module.exports = __webpack_public_path__ + "static/media/downloadGreen.fe79d494.svg";